<template>
    <b-nav id="topNavBar" class="top-navbar">
        <div class="logo-container">
            <b-navbar-brand href="/">
                <img class="brand-logo" src="https://cdn.ritekit.com/assets/img/ritetag/logo.svg">
            </b-navbar-brand>

            <span class="logo-divider">/</span>
            <span class="logo-by">by</span>
            <a class="logo-ritekit" href="https://ritekit.com">
                <img src="https://cdn.ritekit.com/assets/img/ritekit/logo.svg">
            </a>
            <Headway/>
        </div>
        <b-btn
            class="auto-complete-toggle"
            size="sm"
            variant="default"
            @click="mobileAutoComplete=!mobileAutoComplete"
        >
            <i class="fas fa-search"></i>
        </b-btn>
        <div class="auto-complete">
            <b-nav-form>
                <b-input-group>
                    <b-form-input
                        placeholder="Search for Hashtags.."
                        v-model="hashtagSearch"
                        @input="showAutoComplete"
                        @focus="showAutoComplete"
                        @keydown.enter.prevent="submitHashtagSearch"
                        @blur="onBlur"
                        @keydown.down.prevent="shiftDown"
                        @keydown.up.prevent="shiftUp"
                        autocomplete="off"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-btn
                            variant="secondary"
                            :href="hashtagSearchLink"
                            ref="hashtagSearchBtn"
                        >
                            <font-awesome-icon :icon="['fas', 'search']" />
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>
                <ul v-show="isAutoCompleteOpen" class="autocomplete-results" ref="autocomplete-results">
                    <div
                      v-for="(suggestion, index) in results"
                      :key="suggestion"
                      :class="{'selected': (selectedSuggestion == index)}"
                      @mousemove="selectSuggestion(index)"
                      @mouseleave="selectNoneSuggestion"
                      @click="submitHashtagSearch"
                      >
                        <a :href="autoCompleteLink+suggestion" class="autocomplete-anchor">
                            <li class="autocomplete-result">{{suggestion}}</li>
                        </a>
                    </div>
                </ul>
            </b-nav-form>
        </div>
        <b-button-group class="product-menu">
            <b-button variant="outline-secondary" href="https://riteforge.com"><img class="nav-ico" src="https://cdn.ritekit.com/assets/img/riteforge/logo-symbol.svg"> Publishing</b-button>
            <b-button variant="outline-secondary" href="https://riteboost.com"><img class="nav-ico" src="https://cdn.ritekit.com/assets/img/riteboost/logo-symbol.svg"> Enhance</b-button>
            <b-button variant="outline-secondary" href="https://rite.ly"><img class="nav-ico" src="https://cdn.ritekit.com/assets/img/ritely/logo-symbol.svg"> Link Ads</b-button>
            <b-button variant="secondary" href="/" ><img class="nav-ico" src="https://cdn.ritekit.com/assets/img/ritetag/logo-symbol.svg"> Hashtags</b-button>
        </b-button-group>
        <b-dropdown class="mobile-dropdown" variant="outline-secondary">
            <template slot="button-content">
                <font-awesome-icon :icon="['fas', 'bars']" fixed-width />
            </template>
            <b-dropdown-item href="https://riteforge.com">
                <img
                    class="nav-ico"
                    src="https://cdn.ritekit.com/assets/img/riteforge/logo-symbol.svg"
                > Publishing
            </b-dropdown-item>
            <b-dropdown-item href="https://riteboost.com">
                <img
                    class="nav-ico"
                    src="https://cdn.ritekit.com/assets/img/riteboost/logo-symbol.svg"
                > Enhance
            </b-dropdown-item>
            <b-dropdown-item href="https://rite.ly">
                <img
                    class="nav-ico"
                    src="https://cdn.ritekit.com/assets/img/ritely/logo-symbol.svg"
                > Link Ads
            </b-dropdown-item>
            <b-dropdown-item href="/">
                <img
                    class="nav-ico"
                    src="https://cdn.ritekit.com/assets/img/ritetag/logo-symbol.svg"
                > Hashtags
            </b-dropdown-item>
        </b-dropdown>
        <b-nav-form v-show="mobileAutoComplete">
            <b-input-group size="sm">
                <b-form-input
                    placeholder="Search for Hashtags.."
                    v-model="hashtagSearch"
                    @input="showAutoComplete"
                    autocomplete="off"
                    class="hashtag-input"
                />
                <b-input-group-append>
                    <b-btn
                        variant="primary"
                        @click="searchLink"
                        :href="hashtagSearchLink"
                    >
                        <font-awesome-icon :icon="['fas', 'search']"/>
                    </b-btn>
                </b-input-group-append>
            </b-input-group>
            <ul v-show="isAutoCompleteOpen" class="autocomplete-results">
                <div v-for="suggestion in results" :key="suggestion">
                    <a :href="autoCompleteLink+suggestion" class="auto-complete-anchor">
                        <li class="autocomplete-result">{{suggestion}}</li>
                    </a>
                </div>
            </ul>
        </b-nav-form>
        <b-dropdown v-if="info.loggedIn" class="user-dropdown float-right" variant="outline-light" right >
            <template slot="button-content">
                <img class="userImg" :src="profileImg">
            </template>
            <b-dropdown-item href="https://ritekit.com/settings">
                <font-awesome-icon :icon="['fas', 'cog']" fixed-width /> Settings
            </b-dropdown-item>
            <b-dropdown-item href="https://ritekit.com/developer/dashboard">
                <font-awesome-icon :icon="['fas', 'code']" fixed-width/> Developers
            </b-dropdown-item>
            <b-dropdown-item href="/affiliates">
                <font-awesome-icon :icon="['fas', 'dollar-sign']" fixed-width/> Affiliates
            </b-dropdown-item>
            <b-dropdown-item href="https://headwayapp.co/ritekit-changelog">
                <font-awesome-icon :icon="['fas', 'gift']" fixed-width/> What's New
            </b-dropdown-item>
            <b-dropdown-item href="http://help.ritekit.com" target="_blank">
                <font-awesome-icon :icon="['fas', 'life-ring']" fixed-width/> Help
            </b-dropdown-item>
            <b-dropdown-item href="https://ritekit.com/support">
                <font-awesome-icon :icon="['fas', 'comments']" fixed-width/> Support
            </b-dropdown-item>
            <b-dropdown-item href="https://ritekit.com/sign/out">
                <font-awesome-icon :icon="['fas', 'sign-out-alt']" fixed-width/> Logout
            </b-dropdown-item>
        </b-dropdown>
        <b-btn v-if="!info.loggedIn" to="/login" variant="primary" class="btn-sign-in">Sign in</b-btn>
    </b-nav>
</template>

<script>
import { mapState } from 'vuex'
import {api} from '../_services'
import Headway from './Headway'

const baseUrl = process.env.RITETAG_URL
export default {
    name: "TopNavBar",
    components: {
        Headway
    },
    props: ['profileImg'],
    data() {
        return {
            isAutoCompleteOpen: false,
            results: [],
            hashtagSearchLink: "",
            autoCompleteLink: `${baseUrl}/best-hashtags-for/`,
            hashtagSearch: "",
            originalSearch: "",
            searchValue: "",
            mobileAutoComplete: false,
            selectedSuggestion: null,
            resultClicked: false

        };
    },
    methods: {
        searchLink() {
            if (this.searchValue.length === 0) {
                this.hashtagSearchLink = `${baseUrl}/hashtag-search`
            } else {
                this.hashtagSearchLink =
                    `${baseUrl}/best-hashtags-for/` + this.searchValue
            }
        },
        showAutoComplete: function () {
          this.selectedSuggestion = null
            if (this.hashtagSearch.length > 3) {
              this.originalSearch = this.hashtagSearch
              if (this.hashtagSearch.charAt(0) === '#') {
                this.searchValue = this.hashtagSearch.slice(1)
              }
              else {
                this.searchValue = this.hashtagSearch
              }
              api.searchHashtags(this.searchValue, 5)
                .then(response => {
                  this.results = []
                  for (let i=0; i<response.data.result.length; i++) {
                    this.results.push(response.data.result[i].hashtag)
                  }
                })
                .catch(err => {
                  // todo
                })
              this.isAutoCompleteOpen = true;
            } else if (this.hashtagSearch.length <= 3) {
                this.isAutoCompleteOpen = false
            }
            this.searchLink()
        },
        submitHashtagSearch: function() {
          this.resultClicked = true
          this.$refs.hashtagSearchBtn.click()
        },
        selectSuggestion: function(index) {
          this.selectedSuggestion = index
          this.hashtagSearch = this.results[index]
          this.searchLink()
        },
        selectNoneSuggestion: function() {
          this.selectedSuggestion = null
        },
        shiftDown: function() {
          if (this.selectedSuggestion === null) {
            this.selectedSuggestion = 0
            this.hashtagSearch = this.results[this.selectedSuggestion]
            this.searchLink()
          }
          else if (this.selectedSuggestion < this.results.length -1) {
            this.selectedSuggestion +=1
            this.hashtagSearch = this.results[this.selectedSuggestion]
            this.searchLink()
          }
          else {
            this.selectedSuggestion = null
            this.hashtagSearch = this.originalSearch
            this.searchLink()
          }
        },
        shiftUp: function() {
          if (this.selectedSuggestion === null ) {
            this.selectedSuggestion = this.results.length -1
          }
          else if (this.selectedSuggestion === 0) {
            this.selectedSuggestion = null
            this.hashtagSearch = this.originalSearch
            this.searchLink()
          }
          else {
            this.selectedSuggestion -=1
            this.hashtagSearch = this.results[this.selectedSuggestion]
            this.searchLink()
          }
        },
        onBlur: function() {
          setTimeout(() => {
            if (this.resultClicked) {
              return
            }
            else {
              this.isAutoCompleteOpen = false
              this.hashtagSearch = this.originalSearch
              this.selectedSuggestion = null
            }
          }, 100)
        }

    },
    computed: {
        ...mapState('account', ['info'])
    }
};
</script>

<style scoped lang="scss">
.top-navbar {
    justify-content: space-between;
}
.auto-complete-toggle {
    display: none;
    margin: 10px;
}
.auto-complete-anchor {
    text-decoration: none;
    color: black;
}
.mobile-dropdown {
    display: none;
    margin-top: 5px;
}

.logo-container {
    margin-top: 2px;
}

.product-menu {
    margin-top: 6px;
    background-color: white;
}

.brand-logo {
    width: 97px;
    height: 30px;
}
.logo-divider {
    font-size: 24px;
    display: inline-block;
    padding-top: 4px;
    vertical-align: top;
    margin-left: -10px;
    margin-right: 2px;
    color: silver;
}
.logo-by {
    color: gray;
    display: inline-block;
    vertical-align: top;
    padding-top: 13px;
    font-size: 14px;
    margin-right: 2px;
}
.logo-ritekit {
    vertical-align: top;
    display: inline-block;
    height: 20px;
    width: 59px;
    margin-top: 12px;
    margin-left: 3px;
}
.autocomplete {
    position: relative;
}
.auto-complete {
    position: relative;
    margin-left: -15px;
    margin-right: 20px;
    margin-top: 6px;
}
.autocomplete-results {
    padding: 0;
    position: absolute;
    top: 77%;
    z-index: 100;
    margin: 0;
    border: 1px solid #eeeeee;
    overflow: auto;
    width: 175px;
    background-color: white;
    width: 184px;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 6px;
    cursor: pointer;
    overflow: hidden;
}

.autocomplete-anchor {
    text-decoration: none;
}

.dropdown-item {
    color:blue;
    padding: 5px 10px !important;
}
.selected {
  background-color: #c12f93;
}

.selected a li {
  color: white;
}

.nav-ico {
    width: 23px;
    height: 20px;
}

.userImg {
    width: 32px;
    height: 32px;
    border-radius: 50%;
}
.user-dropdown {
    margin-top: 6px;
    /deep/ button {
        padding:0px;
    }
}

.btn-sign-in {
    margin-top: 6px;
}
@media screen and (max-width: 1160px) {
    .logo-by {
        display: none;
    }
    .logo-divider {
        display: none;
    }
    .logo-ritekit {
        display: none;
    }
    .auto-complete {
        display: none;
    }
    .auto-complete-toggle {
        display: block;
    }
}

@media screen and (max-width: 870px) {
    .top-nav-link {
        display: none;
    }
    .upgrade-button {
        display: none;
    }
    .mobile-dropdown {
        display: flex;
    }
    .product-menu {
        display: none;
    }
}
</style>
